
export default class FundLogResponseModel {
    public fieldName: string = '';
    public oldValue: string = '';
    public newValue: string = '';
    public createdDateTimeUtc?: Date;
    public createdBy: string = '';
}
